const dispatch = require("~/store.js").dispatch;

const config = require("~/config.js");
const server = require("~/server.js");
const navigator = require("~/navigator.js");

const events = require("./auditCreationEvents.js");

const auditCreationDispatchers = {
    Create(auditTypeName, facNumber, auditPeriod) {
        dispatch((thunkDispatch) => {
            const started = events.Started.New();

            thunkDispatch(started);

            const url = `audit/${auditTypeName}/${facNumber}/${auditPeriod}`;

            let tries = 0;

            const poster = () => {
                server.Post(url)
                    .then((response) => {
                        const location = response.headers.get("location");
                        const segs = location.split('/');

                        if (segs.length < 4) {
                            throw `${location} does not have the expected number of segments.`;
                        }

                        const newSurveyID = segs[3];

                        const completed = events.Completed.New();

                        thunkDispatch(completed);

                        navigator.OpenSurvey(auditTypeName, facNumber, newSurveyID);
                    })
                    .catch((ex) => {
                        if (tries < config.ServerRequestRetries && ex.response.status >= 500) {
                            tries++;
                            
                            setTimeout(poster, config.ServerRequestDelayMS);
                        }
                        else {
                            const errored = events.Errored.New(ex);

                            thunkDispatch(errored);
                        } 
                    });
            };

            poster();
        });
    },
    ClearError() {
        const clearError = events.ClearError.New();

        dispatch(clearError);
    }
};

module.exports = auditCreationDispatchers;


// WEBPACK FOOTER //
// ./src/events/auditCreation/auditCreationDispatchers.js